import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'

import { NameSpace } from '../types'
import { RootState } from '..'

export interface SessionNotificationState {
  languageModalShown: boolean
  aiUsageFilterHintShown: boolean
}

const initialState: SessionNotificationState = {
  languageModalShown: false,
  aiUsageFilterHintShown: false,
}

export const sessionNotificationsProcess = createSlice({
  initialState,
  name: NameSpace.SessionNotifications,
  reducers: {
    markLangModalAsShown: (state) => {
      state.languageModalShown = true
    },
    markAiUsageFilterHintAsShown: (state) => {
      state.aiUsageFilterHintShown = true
    },
  },
})

const getState = (state: RootState): SessionNotificationState =>
  state.sessionNotifications

export const getIsLangModalShown = createDraftSafeSelector(
  getState,
  ({ languageModalShown }) => languageModalShown,
)
export const getIsAiUsageFilterHintShown = createDraftSafeSelector(
  getState,
  ({ aiUsageFilterHintShown }) => aiUsageFilterHintShown,
)
export const { markLangModalAsShown, markAiUsageFilterHintAsShown } =
  sessionNotificationsProcess.actions
